var map = {
	"./FNOL.png": 8638,
	"./accident.png": 9136,
	"./fileUploadBox.png": 9481,
	"./fire.png": 3548,
	"./gaig-logo.png": 5947,
	"./logo.svg": 9574,
	"./others.png": 7341,
	"./step1.png": 1894,
	"./step2.png": 190,
	"./theft.png": 6413,
	"./upload.png": 9938,
	"./water.png": 9976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;